import { Role } from "@organizations/models";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";

export interface OrganizationAssignableRoleState extends EntityState<Role> {
  loading: boolean;
  loaded: boolean;
}

export const organizationAssignableRoleAdapter: EntityAdapter<Role> = createEntityAdapter<Role>({
  selectId: (organizationAssignableRole: Role) => organizationAssignableRole.id,
  sortComparer: (orgAssignableRole1, orgAssignableRole2) =>
    orgAssignableRole1.displayName.localeCompare(orgAssignableRole2.displayName)
});
